var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"q-pa-md"},[_c('h6',[_vm._v("EN DESARROLLO DE DASHBOARD PARA REPORTES")])])
}
var staticRenderFns = []

export { render, staticRenderFns }